var site = site || {};
site.tjon = {
    ivr: function() {
        $.ajax({
            method: 'post',
            url: '/_/moya/tjon/ajax/ivr',
            data: {
                permno: $('#vehiclePermno', '#tjon').val(),
            }
        }).done(function(response) {
            if (response) {
				if (response.insuranceCompanyId) {
					$('#insuranceCompanyId').val(response.insuranceCompanyId);
				}
                if (response.vehicleMake) {
                    $('#vehicleMake').val(response.vehicleMake);
                }
                if (response.vehicleModel) {
                    $('#vehicleModel').val(response.vehicleModel);
                }
				if (response.vehicleMilage) {
					$('#vehicleMilage').val(response.vehicleMilage);
				}
                if (response.vehicleYear) {
                    $('#vehicleYear').val(response.vehicleYear);
                }
                if (response.vehicleColor) {
                    $('#vehicleColor').val(response.vehicleColor);
                }
				if (response.vehicleFuel) {
					$('input[value="'+response.vehicleFuel+'"]','#elm_vehicleFuel').prop("checked", true);
				}
				if (response.vehicleEnginecc) {
					$('#vehicleEnginecc').val(response.vehicleEnginecc);
				}
				if (response.vehicleGears) {
					$('input[value="'+response.vehicleGears+'"]','#elm_vehicleGears').prop("checked", true);
				}
				if (response.vehicleDoors) {
					$('#vehicleDoors').val(response.vehicleDoors);
				}
                if (response.ownerName) {
                    $('#ownerName').val(response.ownerName);
                }
				if (response.ownerKennitala) {
					$('#ownerKennitala').val(response.ownerKennitala);
				}
                if (response.ownerAddress) {
                    $('#ownerAddress').val(response.ownerAddress);
                }
                if (response.ownerPostalCode) {
                    $('#ownerPostalCode').val(response.ownerPostalCode);
                }
            }
        });
    }
};